import Modal from './Modal'

export default function ModalShare({ close, children }) {
  return <Modal onClose={close}>{children}</Modal>
}
